import React from 'react';
import '../style/Kyagu.scss';
// component
import Header from '../components/public/Header';
import PhotoGallery from '../components/thirdParty/PhotoGallery';
// React Bootstrap
import { Container, Row, Col, Image, Tab, Nav } from 'react-bootstrap';
// React redux
import { connect } from 'react-redux';

function LodueRinchen({ lang }) {
    const lodueGyaltsen =
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FLodueRinchen.png?alt=media&token=42770f99-5001-4942-9202-fa65bdbbc265';


    return (
        <>
            <Header />
            <Container className='kyagu'>
                <div className='kyaguBody pt-4 pr-5 pl-5'>
                    <Tab.Container id='left-tabs' defaultActiveKey='1'>
                        {/* Header Bar content */}
                        <Row className=''>
                            <Col>
                                <Tab.Content className='headerBanner'>
                                    <Tab.Pane eventKey='1' className='tabPane'>
                                        {/* Header Image */}
                                        <Image src={lodueGyaltsen} rounded fluid width='25%' />
                                        {/* Title */}
                                        {/* {lang === 'CH' ? (
                                            <h3 className='text-left text-secondary chinese mb-3 '>
                                                達瑪旺秋 1127-1199
                                            </h3>
                                        ) : lang === 'TIB' ? (
                                            <h3 className='text-left text-secondary tibetan_Dutsa mb-3'>
                                                བོད་ཡིག་
                                            </h3>
                                        ) : (
                                                    <h3 className='text-left text-secondary mb-3'>English</h3>
                                                )} */}
                                    </Tab.Pane>
                                </Tab.Content>
                            </Col>
                        </Row>
                        {/* Left Key Buttons */}
                        <Row>
                            <Col sm={5} md={3}>
                                <Nav variant='pills' className='flex-column '>
                                    {/* Tap 1 */}
                                    <Nav.Item className='navItem'>
                                        <Nav.Link eventKey='1'>
                                            {lang === 'CH' ? (
                                                <h4>自傳</h4>
                                            ) : lang === 'TIB' ? (
                                                <h4>རྣམ་ཐར།</h4>
                                            ) : (
                                                        <h4>english</h4>
                                                    )}
                                        </Nav.Link>
                                    </Nav.Item>
                                    {/* Tap 2 */}
                                    <Nav.Item className='navItem'>
                                        <Nav.Link eventKey='2'>
                                            {lang === 'CH' ? (
                                                <h4>歷代轉世</h4>
                                            ) : lang === 'TIB' ? (
                                                <h4>སྐུ་ཕྲེང་།</h4>
                                            ) : (
                                                        <h4>english</h4>
                                                    )}
                                        </Nav.Link>
                                    </Nav.Item>
                                    {/* Tap 3 */}
                                    <Nav.Item className='navItem'>
                                        <Nav.Link eventKey='3'>
                                            {lang === 'CH' ? (
                                                <h4>大手印</h4>
                                            ) : lang === 'TIB' ? (
                                                <h4>ཕྱག་ཆེན།</h4>
                                            ) : (
                                                        <h4>english</h4>
                                                    )}
                                        </Nav.Link>
                                    </Nav.Item>
                                    {/* Tap 4 */}
                                    <Nav.Item className='navItem'>
                                        <Nav.Link eventKey='4'>
                                            {lang === 'CH' ? (
                                                <h4>那若六法</h4>
                                            ) : lang === 'TIB' ? (
                                                <h4> ཆོས་དྲུག །</h4>
                                            ) : (
                                                        <h4>english</h4>
                                                    )}
                                        </Nav.Link>
                                    </Nav.Item>
                                    {/* Tap 5 */}
                                    <Nav.Item className='navItem'>
                                        <Nav.Link eventKey='5'>
                                            {lang === 'CH' ? (
                                                <h4>道歌</h4>
                                            ) : lang === 'TIB' ? (
                                                <h4>མགུར།</h4>
                                            ) : (
                                                        <h4>english</h4>
                                                    )}
                                        </Nav.Link>
                                    </Nav.Item>
                                    {/* Tap 6 */}
                                    <Nav.Item className='navItem'>
                                        <Nav.Link eventKey='6'>
                                            {lang === 'CH' ? (
                                                <h4>教言</h4>
                                            ) : lang === 'TIB' ? (
                                                <h4>ཞལ་གདམ།</h4>
                                            ) : (
                                                        <h4>english</h4>
                                                    )}
                                        </Nav.Link>
                                    </Nav.Item>
                                    {/* Tap 7 */}
                                    <Nav.Item className='navItem'>
                                        <Nav.Link eventKey='7'>
                                            {lang === 'CH' ? (
                                                <h4>自傳</h4>
                                            ) : lang === 'TIB' ? (
                                                <h4>འདོན་ཆ།</h4>
                                            ) : (
                                                        <h4>english</h4>
                                                    )}
                                        </Nav.Link>
                                    </Nav.Item>
                                    {/* Tap 8 */}
                                    <Nav.Item className='navItem'>
                                        <Nav.Link eventKey='8'>
                                            {lang === 'CH' ? (
                                                <h4>法相</h4>
                                            ) : lang === 'TIB' ? (
                                                <h4>སྐུ་བརྙན།</h4>
                                            ) : (
                                                        <h4>english</h4>
                                                    )}
                                        </Nav.Link>
                                    </Nav.Item>
                                    {/* Tap 9 */}
                                    <Nav.Item className='navItem'>
                                        <Nav.Link eventKey='9'>
                                            {lang === 'CH' ? (
                                                <h4>醫學</h4>
                                            ) : lang === 'TIB' ? (
                                                <h4>སྨན།</h4>
                                            ) : (
                                                        <h4>english</h4>
                                                    )}
                                        </Nav.Link>
                                    </Nav.Item>
                                    {/* Tap 10 */}
                                    <Nav.Item className='navItem'>
                                        <Nav.Link eventKey='10'>
                                            {lang === 'CH' ? (
                                                <h4>天象</h4>
                                            ) : lang === 'TIB' ? (
                                                <h4>རྩིས།</h4>
                                            ) : (
                                                        <h4>english</h4>
                                                    )}
                                        </Nav.Link>
                                    </Nav.Item>
                                    {/* Tap 11 */}
                                    <Nav.Item className='navItem'>
                                        <Nav.Link eventKey='11'>
                                            {lang === 'CH' ? (
                                                <h4>書法</h4>
                                            ) : lang === 'TIB' ? (
                                                <h4>ཡིག་གཟུགས།</h4>
                                            ) : (
                                                        <h4>english</h4>
                                                    )}
                                        </Nav.Link>
                                    </Nav.Item>
                                    {/* Tap 12 */}
                                    <Nav.Item className='navItem'>
                                        <Nav.Link eventKey='12'>
                                            {lang === 'CH' ? (
                                                <h4>佛教藝術</h4>
                                            ) : lang === 'TIB' ? (
                                                <h4>སྒྱུ་རྩལ། </h4>
                                            ) : (
                                                        <h4>english</h4>
                                                    )}
                                        </Nav.Link>
                                    </Nav.Item>
                                    {/* Tap 13 */}
                                    <Nav.Item className='navItem'>
                                        <Nav.Link eventKey='13'>
                                            {lang === 'CH' ? (
                                                <h4>閉關聖地</h4>
                                            ) : lang === 'TIB' ? (
                                                <h4>སྒྲུབ་གནས། </h4>
                                            ) : (
                                                        <h4>english</h4>
                                                    )}
                                        </Nav.Link>
                                    </Nav.Item>
                                    {/* Tap 14 */}
                                    <Nav.Item className='navItem'>
                                        <Nav.Link eventKey='14'>
                                            {lang === 'CH' ? (
                                                <h4>加持物</h4>
                                            ) : lang === 'TIB' ? (
                                                <h4>བྱིན་རླབས་ཀྱི་དངོས་པོ། </h4>
                                            ) : (
                                                        <h4>english</h4>
                                                    )}
                                        </Nav.Link>
                                    </Nav.Item>
                                    {/* Tap 15*/}
                                    <Nav.Item className='navItem'>
                                        <Nav.Link eventKey='15'>
                                            {lang === 'CH' ? (
                                                <h4>紀念日</h4>
                                            ) : lang === 'TIB' ? (
                                                <h4>རྗེས་དྲན། </h4>
                                            ) : (
                                                        <h4>english</h4>
                                                    )}
                                        </Nav.Link>
                                    </Nav.Item>
                                    {/* Tap 16 */}
                                    <Nav.Item className='navItem'>
                                        <Nav.Link eventKey='16'>
                                            {lang === 'CH' ? (
                                                <h4>舍利塔</h4>
                                            ) : lang === 'TIB' ? (
                                                <h4>མཆོད་གདུང་། </h4>
                                            ) : (
                                                        <h4>english</h4>
                                                    )}
                                        </Nav.Link>
                                    </Nav.Item>
                                </Nav>
                            </Col>

                            {/* Content */}
                            <Col sm={7} md={9}>
                                <Tab.Content className='tabContent'>

                                    <Tab.Pane eventKey='1' className='tabPane'> Tab pane 1</Tab.Pane>

                                </Tab.Content>
                            </Col>
                        </Row>
                    </Tab.Container>
                </div>
            </Container >
        </>
    );
}

const mapStateToProps = (state) => {
    return {
        lang: state.lang.lang,
    };
};

export default connect(mapStateToProps)(LodueRinchen);
